<template>
  <div
    class="background"
    :class="[type === 'review' && 'background-review']"
  >
    <div class="rock"></div>
    <div class="dialog wrong-book-dialog">
      <div class="content">
        <div class="close" @click="onClose"></div>
        <div class="main">
          <div class="nav">
            <div class="select-wrapper">
              <el-select
                popper-class="select-down"
                v-model="currentProject">
                <el-option
                  v-for="item in selectList.project"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                >
                </el-option>
              </el-select>
              <template>
                <el-select
                  popper-class="select-down"
                  v-model="currentBook">
                  <el-option
                    v-for="item in selectList.book"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </template>
            </div>
          </div>
          <div class="level-list">
            <div class="level-content">
              <div class="level">
                <div class="level-box">
                  <div
                    class="level-item-box"
                    v-for="(item, index) in passList"
                    @click="start(item)"
                    :key="index">
                    <div class="level-item" v-if="item.itemCode !== 'boss'">
                      <div
                        class="level-name"
                      >
                        {{item.itemType}} - {{item.itemCode}}
                      </div>
                      <div class="level-star" v-if="item.isUnlock">
                        <div
                          :class="[
                            item.star === 1 ||
                            item.star === 2 ||
                            item.star === 3 ?
                            'lightStar' :
                            'star']"
                        >
                        </div>
                        <div
                          :class="[item.star === 2 || item.star === 3 ? 'lightStar' : 'star']"
                        >
                        </div>
                        <div :class="[item.star === 3 ? 'lightStar' : 'star']"></div>
                      </div>
                      <div v-else class="lock"></div>
                    </div>
                    <div class="boss" v-else>
                      <div class="boss-name"></div>
                      <div class="boss-star"></div>
                      <div v-if="!item.isUnlock" class="lock"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="info">
                <div class="info-box">
                  <div class="user-info">
                    <div class="head-photo">
                      <img :src="info.userAvatar" alt>
                    </div>
                    <div class="user-name">
                      <span>lv.{{info.level}}</span>
                      <span>{{info.title}}</span>
                    </div>
                  </div>
                  <div class="hard-integral">
                    <div class="hard-box" @click="changeType" v-if="toggleButton.length">
                      <div class="hard"></div>
                      <div class="hard-name">难度</div>
                    </div>
                    <div class="integral-box" @click="openIntegralDetail">
                      <div class="integral"></div>
                      <div class="integral-name">积分{{info.integral}}</div>
                    </div>
                  </div>
                  <div class="plan">
                    <div class="experience">
                      <div class="logo"></div>
                      <div class="line"></div>
                      <div class="bar">
                        <div class="proportion">经验值：{{info.exp + '%'}}</div>
                        <div
                          class="experience-stripe"
                          :style="stripeWidth(info.exp)"
                          >}</div>
                      </div>
                    </div>
                    <div class="mobility">
                      <div class="logo mobility-logo"></div>
                      <div class="line"></div>
                      <div class="bar">
                        <div class="proportion">行动力：{{info.energy+ '%'}}</div>
                        <div class="mobility-stripe" :style="stripeWidth(info.energy)"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <integral-detail-dialog
      v-if="isShowIntegralDetails"
      key="integralDetails"
      @close="isShowIntegralDetails = false"
    />
  </div>
</template>

<script>
/* eslint-disable */
import { Select, Option } from 'element-ui';
import api from '@/api/graphql/level';
import server from '@/api/course';
import IntegralDetailDialog from '../personal/IntegralDetailDialog.vue';
import utils from '@/services/utils';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ElSelect: Select,
    ElOption: Option,
    IntegralDetailDialog,
  },
  data() {
    return {
      passList: [],
      selectList: {
        book: [],
        project: [],
      },
      isShowIntegralDetails: false,
      currentProject: null,
      currentBook: null,
      info: {
        afterTime: 0,
        energy: 0,
        exp: 0,
        integral: 0,
        level: 0,
        title: "",
      },
      type: 'view',
      toggleButton: [],
      refreshEnergy: null,
    };
  },
  computed: {
    stripeWidth() {
      return function(proportion) {
        let str=proportion+ '%';
        return `width: ${str}`;
      };
    }
  },
  watch: {
    currentProject() {
      this.getBookList();
    },
    show() {
      if (this.show) {
        api.getBookList({projectId: this.currentProject}).then(({bookList}) => {
          this.selectList = bookList;
          if (bookList.project.length && !this.currentProject) {
            this.currentProject = bookList.project[0].id;
          }
          if (bookList.book.length && !this.currentBook) {
            this.currentBook = bookList.book[0].id;
          }
          this.getLevelList();
        });
        this.getLevelUserInfo();
      } else {
        clearInterval(this.refreshEnergy);
      }
    },
    currentBook(newVal, oldVal) {
      if(this.currentBook && oldVal) {
        this.getLevelList();
      }
    },
  },
  methods: {
    onClose() {
      this.$emit('change', {
        scene: 'index',
      });
    },
    changeType() {
      if (this.type === 'view') {
        this.type = 'review';
      } else {
        this.type = 'view';
      }
      this.getLevelList();
    },
    getBookList() {
      api.getBookList({projectId: this.currentProject}).then(({bookList}) => {
        this.selectList = bookList;
        if (bookList.book.length) {
          this.currentBook = bookList.book[0].id;
        }
      });
    },
    openIntegralDetail() {
      this.isShowIntegralDetails = true;
    },
    getLevelList() {
      api.getLevelList({bookId: this.currentBook, type:this.type}).then(({levelList}) => {
        const { passList, toggleButton} = levelList;
        this.passList = passList;
        this.toggleButton = JSON.parse(toggleButton);
      })
    },
    getLevelUserInfo() {
      api.getLevelUserInfo().then(({levelUserInfo}) => {
        this.info = levelUserInfo;
        if (levelUserInfo.afterTime) {
          this.refreshEnergy = setInterval(() => {
            this.getLevelEnergy();
          }, levelUserInfo.afterTime * 1000);
        }
      })
    },
    getLevelEnergy () {
      api.getLevelEnergy().then(({levelEnergy}) => {
        this.info = {
          ...this.info,
          ...levelEnergy,
        };
      });
    },
    fetchCourseList() {
      server.getWrongBookCourses()
        .then(res => {
          this.projectList = res;
          this.currentProject = this.projectList.length ? this.projectList[0].code : '';
          this.getSubjectList(this.currentProject);
        });
    },
    start(item) {
      if (!item.isUnlock) return;
      const course = utils.Array.find(this.selectList.book, { id: this.currentBook }, 'id');
      this.$emit('change', {
        scene: 'quizzesDialog',
        params: {
          course: {
            ...course,
          },
          unit: {
            id: item.itemType,
          },
          type: course.type === 'BDC' ? 'bdc_level' : 'level',
          mode: this.type,
          levelCode: item.itemCode,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common/dialog.scss";
@import "@/styles/variables.scss";
.background-review {
  background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/47f690b5aec32cb8f2b9dc0119b35ef1.png') !important;
  .rock {
    background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/3242bb28d3f824179d795009f11657d5.png') !important;
  }
  .wrong-book-dialog {
    .main {
      /deep/ .el-select {
        .el-input {
          .el-input__inner {
            background: #00778B !important;
          }
        }
      }
    }
    .level {
      background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/565d71c5a59cf7bc90603df1531d4d32.png') !important;
      cursor: pointer;
      .level-name {
        background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/af4f2c446fcd59d580366b16260e2afd.png') !important;
        color: #206472 !important;
        &:active {
          transform: scale(.95);
        }
      }
    }
    .info {
      background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/3bf2ed2ab4ddabde0af4c89cefe6a8f1.png') !important;
      .user-info {
        background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/ad97b44cc3ac1c0064f55faea57e921e.png') !important;
        .user-name {
          color: #206472 !important;
        }
      }
    }
  }
}
.background {
  position: absolute;
  top: 0;
  left: 80px;
  right: 0;
  bottom: 0;
  background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/93358c2b5acd1737f041bd321afcc3a7.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .rock{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/52f688105561a2950a0de59b217bd693.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .wrong-book-dialog {
    width: 70vw;
    .content {
      display: flex;
      flex-direction: column;
      .title {
        padding: 2vh 2.4vh;
        font-size: 2.4vh;
      }
      .main {
        flex: 1;
        padding: 2vh 2vh 0;
        border-radius: 24px;
        overflow: hidden;
        .nav {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1vh 1vh 1vh 2vh;
          .select-wrapper {
            .select-title {
              margin-left: 5vh;
              color: $primary;
              font-weight: 700;
            }
            /deep/ .el-select:nth-of-type(2) {
              width: 280px;
              margin-left: 30px;
            }
            /deep/ .el-select {
              width: 150px;
              .is-focus {
                .el-input__inner {
                  border-color: $primary;
                }
              }
              .el-input {
                .el-input__inner {
                  &:focus {
                    border-color: $primary;
                  }
                  color: #F9DD50;
                  font-weight: bold;
                  font-size: 16px;
                  border-radius: 24px;
                  background: #5A5FEF;
                  box-shadow: 0px -6px 18px 0px rgba(255, 255, 255, 0.56);
                  opacity: 0.82;
                  border-radius: 32px;

                }
                .el-input__suffix {
                  .el-input__suffix-inner {
                    .el-select__caret {
                      font-size: 3vh;
                      font-weight: 700;
                      color:#F9DD50;
                    }
                  }
                }
              }
            }
            /deep/ .search-input {
              width: 240px;
              .el-input-group__append {
                background: $primary;
                border-width: 1px 0;
                border-color: $primary;
                &:hover {
                  filter: brightness(108%);
                }
                .el-button {
                  .el-icon-search {
                    color: #fff;
                  }
                }
              }
              .is-active, .el-input__inner:focus {
                border-color: $primary;
              }
            }
          }
        }
        .level-list {
          min-height: 70vh;
          .level-content {
            display: flex;
            align-items: flex-start;
            height: 65vh;
            margin-top: 4vh;
            .level {
              height: 100%;
              width: 45vw;
              padding: 3vw;
              box-sizing: border-box;
              background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/2465fc02ce6e672322ff234fedbb7861.png');
              background-repeat: no-repeat;
              background-size: 100% 100%;
              overflow: auto;
              .level-box {
                height: 100%;
                width: 100%;
                overflow: auto;
              }
              .level-item-box {
                float: left;
                width: 5vw;
                height: 6.8vw;
                margin: 2vh 2vw;
              }
              .boss {
                position: relative;
                .boss-name {
                  position: absolute;
                  top: -0.5vw;
                  left: -1vw;
                  width: 7vw;
                  height: 7vw;
                  background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/e347332db51c97c7e8cdecce21deacf2.png');
                  background-repeat: no-repeat;
                  background-size: 100% 100%;
                  cursor: pointer;
                  &:active {
                    transform: scale(.95);
                  }
                }
                .boss-star {
                  position: absolute;
                  top: 4.4vw;
                  width: 5vw;
                  height: 1.8vw;
                  background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/e96d8dd092b41acfe93597ec423921ac.png');
                  background-repeat: no-repeat;
                  background-size: 100% 100%;
                  cursor: pointer;
                }
                .lock{
                  position: absolute;
                  right: 0;
                  bottom: -5.7vw;
                  width: 1.8vw;
                  height: 2.5vw;
                  background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/f7bdd633373deecaa5a7f8bc84f8616d.png');
                  background-repeat: no-repeat;
                  background-size: 100% 100%;
                }
              }
              .level-item {
                position: relative;
                cursor: pointer;
                .level-name {
                  width: 5vw;
                  height: 5vw;
                  background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/c3033a7f69ac6939aafe199d476539f7.png');
                  background-repeat: no-repeat;
                  background-size: 100% 100%;
                  font-size: 1.3vw;
                  font-weight: bold;
                  text-align: center;
                  line-height: 5vw;
                  color: #C18F45;
                  &:active {
                    transform: scale(.95);
                  }
                }
                .lock{
                  position: absolute;
                  right: 0;
                  bottom: -0.7vw;
                  width: 1.8vw;
                  height: 2.5vw;
                  background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/f7bdd633373deecaa5a7f8bc84f8616d.png');
                  background-repeat: no-repeat;
                  background-size: 100% 100%;
                }
                .level-star{
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  position: relative;
                  .star{
                    width: 1.3vw;
                    height: 1.5vw;
                    margin: 1vh 0.2vw;
                    background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/bb3c2181071d5fc416325e815351cd23.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                  }
                  .lightStar{
                    width: 1.3vw;
                    height: 1.5vw;
                    margin: 1vh 0.2vw;
                    background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/2ce5b22530be4992c3a0bda0141d6500.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                  }
                }
              }
            }
            .info {
              height: 100%;
              width: 21vw;
              margin-left: 4vw;
              padding: 3vw 2.8vw;
              box-sizing: border-box;
              background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/2465fc02ce6e672322ff234fedbb7861.png');
              background-repeat: no-repeat;
              background-size: 100% 100%;
              overflow: auto;
              .info-box{
                width: 100%;
                height: 100%;
                overflow: auto;
              }
              .user-info {
                display: flex;
                align-items: center;
                box-sizing: border-box;
                width: 100%;
                margin-top: 2vh;
                padding: 10px;
                height: 4.2vw;
                background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/ef6f7d5cd9cb67af1b20b9f82194e76a.png');
                border-radius: 12px;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                .head-photo {
                  width: 2.7vw;
                  height: 2.7vw;
                  border-radius: 50%;
                  padding: 5px;
                  background: #C18F45;
                  img {
                    width: 2.7vw;
                    height: 2.7vw;
                  }
                }
                .user-name {
                  flex: 1;
                  font-size: 1.1vw;
                  margin-left: 1vw;
                  color: #C69850;
                  font-weight: bold;
                  span:nth-of-type(2) {
                    margin-left: 0.7vw;
                  }
                }
              }
              .hard-integral {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 5vw;
                width: 100%;
                margin-top: 40px;
                .hard-box {
                  margin: 0 2.2vw;
                  cursor: pointer;
                  .hard {
                    width: 4.2vw;
                    height: 4.2vw;
                    background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/1fe4d290e0590913eb5d700ae174b27e.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    cursor: pointer;
                    &:active {
                      transform: scale(.95);
                    }
                  }
                  .hard-name {
                    margin-top: 10px;
                    text-align: center;
                    font-size: 0.9vw;
                    font-weight: bold;
                  }
                }
                .integral-box {
                  margin: 0 2.2vw;
                  .integral {
                    width: 4.2vw;
                    height: 4.2vw;
                    background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/e717d0ad2d664a01ad9ca70addd266bf.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    cursor: pointer;
                    &:active {
                      transform: scale(.95);
                    }
                  }
                  .integral-name {
                    margin-top: 10px;
                    text-align: center;
                    font-size: 0.9vw;
                    font-weight: bold;
                  }
                }
              }
              .plan {
                margin-top: 40px;
                .experience {
                  display: flex;
                  align-items: center;
                  position: relative;
                  width: 100%;
                  height: 4.8vw;
                }
                .mobility {
                  display: flex;
                  align-items: center;
                  position: relative;
                  width: 100%;
                  height: 4.8vw;
                  margin-top: 25px;
                }
                .bar {
                  position: absolute;
                  left: 22%;
                  width: 72%;
                  height: calc(71.8% * 0.54);
                  border-radius: 30px;
                  background: #777;
                  z-index: 1;
                  .proportion {
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    width: 100%;
                    height: 0.9vw;
                    line-height: 0.9vw;
                    margin: auto;
                    font-size: 0.9vw;
                    color: #FADF96;
                    font-weight: bold;
                    text-align: center;
                    z-index: 5;
                  }
                }
                .logo {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 30%;
                  padding-top: calc(31% * 1);
                  z-index: 3;
                  background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/d8e6bdc0aa00ce62f9d2b3228a933975.png');
                  background-repeat: no-repeat;
                  background-size: 100% 100%;
                }
                .mobility-logo {
                  background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/27c59108c3a2315500b33936c90c3a42.png');
                }
                .line {
                  position: absolute;
                  right: 0;
                  width: 86%;
                  padding-top: calc(86% * 0.25);
                  margin: auto;
                  z-index: 1;
                  background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/28a7a2e65d9097e95b36c8e74a89a430.png');
                  background-repeat: no-repeat;
                  background-size: 100% 100%;
                }
                .mobility-stripe {
                  display: flex;
                  align-items: center;
                  position: absolute;
                  left: 0;
                  height: 100%;
                  border-radius: 30px;
                  z-index: 2;
                  background-image: repeating-linear-gradient(-45deg,#dd5252,#dd5252 15px,#bf3737 0,#bf3737 30px);
                }
                .experience-stripe {
                  display: flex;
                  align-items: center;
                  position: absolute;
                  left: 0;
                  height: 100%;
                  border-radius: 30px;
                  z-index: 2;
                  background-image: repeating-linear-gradient(-45deg,#9fd32d,#9fd32d 15px,#71bc29 0,#71bc29 30px);
                }
              }
            }
          }
        }
      }
    }
  }
  .select-down {
    .el-scrollbar {
      .el-select-dropdown__wrap {
        .el-scrollbar__view {
          .selected {
            background: rgba(0, 0, 0, 0);
            box-shadow: 0px -6px 18px 0px rgba(255, 255, 255, 0.56);
            opacity: 0.82;
            border-radius: 32px;
          }
        }
      }
    }
  }
}
.dialog .content{
  background: none !important;
}

</style>
